import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "plant-accounts"

function* loadPlantAccount(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadPlantAccount.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadPlantAccount.failure(getErrorMsg(error)));
  }
}

function* showPlantAccount(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showPlantAccount.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showPlantAccount.failure(getErrorMsg(error)));
  }
}

function* createPlantAccount(action) {
  try {
    const { params, token } = action.payload;

    const payload = {
      acc_no: params.acc_no,
      acc_name: params.acc_name,
      bank_id: params.bank_id,
      plant_ids: params.plant_ids,
      company_id: params.company_id,
    };

    const res = yield fetcher.post(`${url}/create`, payload, token);
    const newId = res.data?.data?.id;

    if (params.imageFile && newId) {
      const formData = new FormData();
      formData.append("image", params.imageFile);
      formData.append("account_id", String(newId));
      const uploadRes = yield fetcher.upload(`${url}/upload-image`, formData, token);
      const bookbankImg = uploadRes?.data?.data?.bookbank_img || null;
      if (bookbankImg) {
        yield fetcher.post(`${url}/update/${newId}`, {
          id: newId,
          acc_no: params.acc_no,
          acc_name: params.acc_name,
          bank_id: params.bank_id,
          company_id: params.company_id,
          plant_ids: params.plant_ids,
          bookbank_img: bookbankImg,
        }, token);
      }
    }
    yield put(actions.createPlantAccount.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createPlantAccount.failure(getErrorMsg(error)));
  }
}

function* updatePlantAccount(action) {
  try {
    const { params, id, token } = action.payload;

    let bookbankImg = null;
    if (params.imageFile) {
      const formData = new FormData();
      formData.append("image", params.imageFile);
      formData.append("account_id", String(id));
      const uploadRes = yield fetcher.upload(`${url}/upload-image`, formData, token);
      bookbankImg = uploadRes?.data?.data?.bookbank_img || null;
    }

    const payload = {
      acc_no: params.acc_no,
      acc_name: params.acc_name,
      bank_id: params.bank_id,
      plant_ids: params.plant_ids,
      removed_plant_ids: params.removed_plant_ids,
      company_id: params.company_id,
    };
    if (bookbankImg) payload.bookbank_img = bookbankImg;
    if (!params.imageFile && params.removeBookbankImg) {
      payload.bookbank_img = "";
    }

    const res = yield fetcher.post(`${url}/update/${id}`, payload, token);
    yield put(actions.updatePlantAccount.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.updatePlantAccount.failure(getErrorMsg(error)));
  }
}

function* deletePlantAccount(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deletePlantAccount.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deletePlantAccount.failure(getErrorMsg(error)));
  }
}

function* importPlantAccount(action) {
  try {
    const { file, company_id, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    formData.append("company_id", company_id);

    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importPlantAccount.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importPlantAccount.failure(getErrorMsg(error)));
  }
}

function* exportPlantAccount(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportPlantAccount.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportPlantAccount.failure(getErrorMsg(error)));
  }
}

export default function* watchPlantAccount() {
  yield all([
    takeEvery(actions.LOAD_PLANT_ACCOUNT.REQUEST, loadPlantAccount),
    takeEvery(actions.SHOW_PLANT_ACCOUNT.REQUEST, showPlantAccount),
    takeEvery(actions.CREATE_PLANT_ACCOUNT.REQUEST, createPlantAccount),
    takeEvery(actions.UPDATE_PLANT_ACCOUNT.REQUEST, updatePlantAccount),
    takeEvery(actions.DELETE_PLANT_ACCOUNT.REQUEST, deletePlantAccount),
    takeEvery(actions.IMPORT_PLANT_ACCOUNT.REQUEST, importPlantAccount),
    takeEvery(actions.EXPORT_PLANT_ACCOUNT.REQUEST, exportPlantAccount),
  ]);
}
